import QuestionContent from "../component/content/QuestionContent";

const Question = () => {
    return (
        <QuestionContent />
    )
};

export default Question;